import api from '@/config/api'
import cloneDeep from '@/third/CloneDeep'
import {
  request
} from '@/tools'

const assignField = (newItem, data, field) => {
  if (data !== undefined) {
    newItem[field] = data
  }
}

const assignCommonData = (config, qu) => {
  const { belongId, id, quTitle, groupId, orderById, isRequired, randOrder,
    imgUrl, imgName, quBeforLogics, quLogics, quoteQuId, page, visibility,
    quNote, hv, minAnswerNum, maxAnswerNum, optionRuleType, exclusiveItemsId,
    mutualItemsId, udfOptionInd, answerRules, randType, shortLabel, screenCode, mediaQuType } = qu
  let { answerConfig } = qu
  config.belongId = belongId
  config.id = id
  config.title = quTitle
  config.groupId = groupId
  config.orderById = orderById
  config.isRequired = isRequired
  config.randOrder = randOrder
  config.randType = randType || '2'
  config.imgUrl = imgUrl
  config.imgName = imgName
  config.answerRules = answerRules || []
  config.quBeforLogics = quBeforLogics || []
  config.quLogics = quLogics || []
  config.quoteQuId = quoteQuId
  config.page = page
  config.visibility = visibility || 1
  config.quNote = quNote || '' // 题目内容
  config.hv = hv // 1图上文下 2图下文上
  config.minAnswerNum = minAnswerNum
  config.maxAnswerNum = maxAnswerNum
  config.optionRuleType = optionRuleType
  config.exclusiveItemsId = exclusiveItemsId
  config.mutualItemsId = mutualItemsId
  config.udfOptionInd = !!udfOptionInd
  config.shortLabel = shortLabel
  config.screenCode = screenCode
  config.mediaQuType = mediaQuType
  if (answerConfig && typeof answerConfig === 'string') {
    answerConfig = JSON.parse(answerConfig)
  }
  config.answerConfig = answerConfig || {
    requireInd: '1',
    otherRequireInd: '1',
    optRandType: '01',
    childRandType: '01',
    fixLastOptionInd: '0',
    optionExInd: '0',
    optionExType: '',
    optionExItems: [],
    answerLimitInd: '0',
    minAnswerNum: '',
    maxAnswerNum: '',
    limitRangeInd: '0',
    paramInt01: '',
    paramInt02: '',
    scoreNumType: '',
    answerValidInd: '0',
    answerRangeType: '',
    rangeTargetId: '',
    uploadType: '01',
    answerOpenInd: '',
    answerOpenTitle: '',
    uniqueInd: '1',
    validInd: '1',
    timeType: '01'
  }
}

const quSave = function (param, el) {
  param = cloneDeep(param)
  var url = el.saveUrl
  delete param.url
  assignField(param, el.belongId, 'belongId')
  assignField(param, el.groupId, 'groupId')
  assignField(param, el.orderById, 'orderById')
  assignField(param, el.quoteQuId, 'quoteQuId')
  assignField(param, el.id, 'quId')
  assignField(param, '2', 'tag')
  assignField(param, el.quNote, 'quNote')
  assignField(param, el.title, 'quTitle')
  assignField(param, el.page, 'page')
  assignField(param, el.imgUrl, 'imgUrl') // 题目图片
  assignField(param, el.imgName, 'imgName') // 图片名称
  assignField(param, el.hv, 'hv') // 1图上文下 2图下文上
  let answerConfig = el.answerConfig
  if (answerConfig && typeof answerConfig === 'object') {
    answerConfig = JSON.stringify(answerConfig)
  }
  assignField(param, answerConfig, 'answerConfig')
  return request({
    url,
    method: 'post',
    data: param
  })
}

const login = param => {
  return request({
    url: api.login,
    method: 'post',
    data: param
  })
}

const logout = param => {
  return request({
    url: api.logout,
    method: 'get',
    data: param
  })
}

const queryProjectList = param => {
  return request({
    url: api.queryProjectList,
    method: 'get',
    data: param
  })
}

const ajaxDelete = function (param) {
  return request({
    url: api.ajaxDelete,
    method: 'get',
    data: param
  })
}

const getSurveyWithAnswer = function (param) {
  return request({
    url: api.getSurveyWithAnswer,
    method: 'get',
    data: param,
    showLoading: false
  })
}

const saveAnswerList = function (param) {
  return request({
    url: api.saveAnswerList,
    method: 'post',
    data: param
  })
}

const addLogicBefor = function (param) {
  return request({
    url: api.addLogicBefor,
    method: 'post',
    data: param
  })
}

const addLogic = function (param) {
  return request({
    url: api.addLogic,
    method: 'post',
    data: param
  })
}

const deleteLogicBefor = function (param) {
  return request({
    url: api.deleteLogicBefor,
    method: 'get',
    data: param
  })
}

const deleteLogic = function (param) {
  return request({
    url: api.deleteLogic,
    method: 'get',
    data: param
  })
}

const deleteAllLogic = function (param) {
  return request({
    url: api.deleteAllLogic,
    method: 'get',
    data: param
  })
}

const getSurveyInfo = param => {
  return request({
    url: api.getSurveyInfo,
    method: 'get',
    data: param,
    showLoading: false
  })
}

const mntSurveyInfo = param => {
  return request({
    url: api.mntSurveyInfo,
    method: 'post',
    data: param,
    showLoading: false
  })
}

const updateQuestionOrderById = questionList => {
  const questionsIds = questionList.reduce((pre, next) => {
    pre.push(next.id)
    return pre
  }, []).join(',')
  return request({
    url: api.updateQuestionOrderById,
    method: 'get',
    data: {
      questionsIds
    }
  })
}

const answerProcess = param => {
  return request({
    url: api.answerProcess,
    method: 'get',
    data: param
  })
}

const nextPage = param => {
  return request({
    url: api.nextPage,
    method: 'get',
    data: param
  })
}

const getQuestionList = param => {
  return request({
    url: api.getQuestionList,
    method: 'get',
    data: param
  })
}

const getLanguage = param => {
  return request({
    url: api.getLanguage,
    method: 'get',
    data: param,
    opts: {
      showLoading: false
    }
  })
}

const getLanguageList = param => {
  return request({
    url: api.getLanguageList,
    method: 'get',
    data: param,
    opts: {
      showLoading: false
    }
  })
}

const getLanguageByType = param => {
  return request({
    url: api.getLanguageByType,
    method: 'get',
    data: param,
    showLoading: false
  })
}

const saveLanguage = param => {
  return request({
    url: api.saveLanguage,
    method: 'post',
    data: param
  })
}

const getStyleById = param => {
  return request({
    url: api.getStyleById,
    method: 'get',
    data: param,
    opts: {
      showLoading: false
    }
  })
}

const saveStyle = param => {
  return request({
    url: api.saveStyle,
    method: 'post',
    data: param
  })
}

const answerTD = param => {
  return request({
    url: api.answerTD,
    method: 'post',
    data: param
  })
}

const getSurveyInfoById = param => {
  return request({
    url: api.getSurveyInfoById,
    method: 'get',
    data: param,
    showLoading: false
  })
}

const deleteSurvey = param => {
  return request({
    url: api.deleteSurvey,
    method: 'get',
    data: param
  })
}

const getSelectList = param => {
  return request({
    url: api.getSelectList,
    method: 'get',
    data: param
  })
}

const downShortUrl = param => {
  return request({
    url: api.downShortUrl,
    method: 'get',
    data: param
  })
}

const saveParam = param => {
  return request({
    url: api.saveParam,
    method: 'post',
    data: {
      id: param.id,
      surveyId: param.surveyId,
      // 1入参2出参
      paramType: param.paramType,
      // 入参名称
      paramName: param.paramName,
      // 出参名称
      outParamName: param.outParamName
    }
  })
}

const getParam = param => {
  return request({
    url: api.getParam,
    method: 'get',
    data: {
      surveyId: param.surveyId
    }
  })
}

const delParam = param => {
  return request({
    url: api.delParam,
    method: 'get',
    data: {
      id: param.id
    }
  })
}

const surveylist = param => {
  return request({
    url: api.surveylist,
    method: 'get',
    data: {
      pageNo: 1,
      pageSize: 99,
      surveyName: null,
      surveyCategory: null,
      ...param
    },
    showLoading: false,
    timeout: 1000 * 60 * 2
  })
}

const getSurveyCode = param => {
  return request({
    url: api.getSurveyCode,
    method: 'get',
    data: {
      type: param.type
    },
    showLoading: false
  })
}

const getSurveySubCode = param => {
  return request({
    url: api.getSurveySubCode,
    method: 'get',
    data: {
      type: param.type,
      parentCode: param.parentCode
    },
    showLoading: false
  })
}

const addLogicBeforGroup = function (param) {
  return request({
    url: api.addLogicBeforGroup,
    method: 'post',
    data: param
  })
}

const deleteLogicBeforGroup = function (param) {
  return request({
    url: api.deleteLogicBeforGroup,
    method: 'get',
    data: param
  })
}

const saveSurveyStatus = function (param) {
  const { id, surveyState } = param
  return request({
    url: api.saveSurveyStatus,
    method: 'get',
    data: {
      id,
      surveyState
    }
  })
}

const addLogicAnswerRule = function (param) {
  return request({
    url: api.addLogicAnswerRule,
    method: 'post',
    data: param
  })
}

const deleteLogicAnswerRule = function (param) {
  const { quId, logicId } = param
  return request({
    url: api.deleteLogicAnswerRule,
    method: 'get',
    data: {
      quId,
      logicId
    }
  })
}

const copySurvey = function (param) {
  const { fromSurveyId, toSurveyId } = param
  return request({
    url: api.copySurvey,
    method: 'get',
    data: {
      fromSurveyId,
      toSurveyId
    }
  })
}

const sendPhoneCode = function (data) {
  return request({
    url: api.sendPhoneCode,
    method: 'get',
    data
  })
}

const sendEmailCode = function (data) {
  return request({
    url: api.sendEmailCode,
    method: 'get',
    data
  })
}

const uploadWxImage = function (param) {
  const { serverId, surveyId } = param
  return request({
    url: api.uploadWxImage,
    method: 'post',
    data: {
      serverId,
      surveyId
    }
  })
}

const uploadWxAudio = function (param) {
  const { serverId, surveyId } = param
  return request({
    url: api.uploadWxAudio,
    method: 'post',
    data: {
      serverId,
      surveyId
    }
  })
}

export {
  request,
  login,
  queryProjectList,
  ajaxDelete,
  getSurveyWithAnswer,
  quSave,
  saveAnswerList,
  addLogicBefor,
  addLogic,
  deleteLogicBefor,
  deleteLogic,
  deleteAllLogic,
  mntSurveyInfo,
  getSurveyInfo,
  updateQuestionOrderById,
  answerProcess,
  nextPage,
  getQuestionList,
  getLanguage,
  getLanguageList,
  getLanguageByType,
  saveLanguage,
  getStyleById,
  saveStyle,
  answerTD,
  getSurveyInfoById,
  deleteSurvey,
  getSelectList,
  downShortUrl,
  saveParam,
  getParam,
  delParam,
  surveylist,
  getSurveyCode,
  getSurveySubCode,
  addLogicBeforGroup,
  deleteLogicBeforGroup,
  saveSurveyStatus,
  addLogicAnswerRule,
  deleteLogicAnswerRule,
  copySurvey,
  uploadWxImage,
  uploadWxAudio,
  logout,
  sendPhoneCode,
  sendEmailCode
}



// WEBPACK FOOTER //
// ./src/service/question.js